import DocumentPlusFill from './DocumentPlusFill';

export default DocumentPlusFill;
